import logo from "../../static/images/logo-para-loading-2.png";
import "./LoadingScreen.css";

export default function LoadingScreen() {
  return (
    <div className="loading-screen">
      <img src={logo} alt="Spectrum" className="loading-screen__logo" />
    </div>
  );
}
